import React, { useState } from 'react';
import { Card } from '@/components/ui/card';
import { History, ChevronDown, ChevronUp, User, Clock } from 'lucide-react';

export const HistorySection = ({ workOrder }) => {
  const [expanded, setExpanded] = useState(false);
  const history = workOrder?.history || [];

  if (history.length === 0) return null;

  const sortedHistory = [...history].sort((a, b) => 
    new Date(b.timestamp) - new Date(a.timestamp)
  );
  const displayedHistory = expanded ? sortedHistory : sortedHistory.slice(0, 5);

  return (
    <Card className="p-4 rounded-xl space-y-3" data-testid="history-section">
      <button
        onClick={() => setExpanded(!expanded)}
        className="flex items-center justify-between w-full"
        data-testid="history-toggle"
      >
        <h3 className="text-sm font-bold text-slate-900 flex items-center gap-2">
          <History className="w-4 h-4 text-indigo-600" />
          Historique des modifications
          <span className="text-xs font-normal text-slate-400 bg-slate-100 px-2 py-0.5 rounded-full">
            {history.length}
          </span>
        </h3>
        {sortedHistory.length > 5 && (
          expanded ? <ChevronUp className="w-4 h-4 text-slate-400" /> : <ChevronDown className="w-4 h-4 text-slate-400" />
        )}
      </button>

      <div className="space-y-1.5 max-h-[400px] overflow-y-auto">
        {displayedHistory.map((entry, i) => (
          <div
            key={i}
            className="flex items-start gap-3 text-sm py-2 px-3 rounded-lg bg-slate-50 hover:bg-slate-100 transition-colors"
            data-testid={`history-entry-${i}`}
          >
            <div className="w-7 h-7 rounded-full bg-indigo-100 text-indigo-600 flex items-center justify-center flex-shrink-0 mt-0.5">
              <User className="w-3.5 h-3.5" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="font-semibold text-slate-800">{entry.user || 'Systeme'}</span>
                {entry.role && (
                  <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-indigo-50 text-indigo-600 font-medium">
                    {entry.role}
                  </span>
                )}
              </div>
              <p className="text-xs text-slate-600 mt-0.5 break-words">{entry.details}</p>
            </div>
            <div className="flex items-center gap-1 text-[10px] text-slate-400 flex-shrink-0 whitespace-nowrap mt-1">
              <Clock className="w-3 h-3" />
              {entry.timestamp ? new Date(entry.timestamp).toLocaleString('fr-CH', {
                day: '2-digit', month: '2-digit', year: '2-digit',
                hour: '2-digit', minute: '2-digit'
              }) : '-'}
            </div>
          </div>
        ))}
      </div>

      {sortedHistory.length > 5 && !expanded && (
        <button
          onClick={() => setExpanded(true)}
          className="text-xs text-indigo-600 hover:text-indigo-800 font-medium"
          data-testid="history-show-more"
        >
          Voir les {sortedHistory.length - 5} modifications precedentes...
        </button>
      )}
    </Card>
  );
};
